import React, { useEffect, useState, useCallback } from 'react';
import {
  Table,
  Input,
  Button,
  Space,
  Message,
  InputNumber,
  Slider,
  Divider,
  Select,
  Tag,
} from '@arco-design/web-react';
import { IconSearch } from '@arco-design/web-react/icon';
import request from '@/request/request';
import { ColumnProps } from '@arco-design/web-react/es/Table';
import { isArray } from 'lodash';
import { VectorTypeList } from './constants';

const VectorSearch: React.FC = () => {
  const columns: ColumnProps[] = [
    {
      title: '命中结果',
      dataIndex: 'deviceParams.name',
      key: 'deviceParams.name',
      render: (_, record) => {
        return (
          <Space>
            <span>{record?.vector?.name || '-'}</span>
            {record?.vector?.isAlias === 1 ? (
              <Tag color="blue">别名</Tag>
            ) : null}
          </Space>
        );
      },
    },
    {
      title: 'Score',
      dataIndex: 'score',
      key: 'score',
    },
  ];
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [topK, setTopK] = useState(20);
  const [part, setPart] = useState(1);

  const loadData = async () => {
    setLoading(true);
    try {
      const response = await request('/aiService/backend/vector/query', {
        data: {
          text: [searchValue],
          topK,
          vectorType: part,
        },
        method: 'POST',
      });
      console.warn('res', response);
      // result 是一个map，取第一个
      const result = response.data.result;
      const firstKey = Object.keys(result)[0];
      setData(result[firstKey] || []);
    } catch (e) {
      Message.error('加载数据失败');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    loadData();
  };

  return (
    <div>
      <Space
        style={{
          marginBottom: 16,
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Space>
          <span>TopK({topK}):</span>
          <Slider
            value={topK}
            onChange={(value) => {
              setTopK(isArray(value) ? value[0] : value);
            }}
            max={50}
            style={{ width: 100 }}
          />
          <Select
            onChange={(value) => {
              setPart(value);
            }}
            value={part}
            style={{ width: 150 }}
            options={VectorTypeList}
          />
          <Divider type="vertical" />
          <Input
            allowClear
            prefix={<IconSearch />}
            placeholder="搜索名称"
            value={searchValue}
            onChange={setSearchValue}
            onPressEnter={handleSearch}
            style={{ width: 220 }}
          />
          <Button type="primary" onClick={handleSearch}>
            搜索
          </Button>
        </Space>
      </Space>
      <Table
        columns={columns}
        data={data}
        loading={loading}
        rowKey="id"
        pagination={false}
      />
    </div>
  );
};

export default VectorSearch;
